import apiClient from "../apiClient";
import { apiNodeBaseUrl } from "../../config";

export const getServices = async () => {
  return apiClient
    .get(`${apiNodeBaseUrl}services?q=status=active`, {})
    .then((response) => {
      return response;
    });
};
